module.exports = __webpack_public_path__ + "static/media/glasses.f18c5a81.gif";